import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useWebsite } from '../../Data/Website';
import Form, { Actions, Switch } from '../../Components/Form';

const WidgetOptions = () => {
    const {website, updateWidgetOptions} = useWebsite(true);

    return <>
        <TopBar left="/more" title="Widget options" />
        <Page>
            {website && <Inner {...{website, updateWidgetOptions}} />}
        </Page>
    </>
}

const Inner = ({website, updateWidgetOptions}) => {
    return <Form data={website.widgetOptions} onSubmit={updateWidgetOptions} goBackOnSubmit>

        <Switch name="useV2" label="Use V2" />

        <Switch name="combinedWidget" label="Use combined widget" />

        <Actions submit={{label: 'Save'}} />
    </Form>
}

export default WidgetOptions;
